// generate random string identifier with 8+ alphanumeric characters
App.namespace('es6.shared.random', () => () => {
  return (+Math.random().toString().substr(2)).toString(35)
});
